import styled from "styled-components";
import { LicenseList } from "./LicenseData";
import { colors } from "styles/global-styles";

const LicenseContainer = styled.main`
    padding: 1rem 2rem;
    white-space: pre-line;

    h3 {
        font-size: 1.5rem;
    }
`;
const Accordion = styled.div`
    details {
        padding: 0.5rem 0;
        border-bottom: 1px solid ${colors.primaryBd};

        &:hover {
            cursor: pointer;
            background-color: ${colors.lightGray};
        }
    }
    
    summary {
        padding: 1rem;
        border-radius: 0.5rem;
        font-size: 1.25rem;
    }
    summary::marker {
        content: '';
    }
    summary::before {
        content: 'L';
        font-size: 1rem;
        font-weight: 700;
        display: inline-block;
        width: 2rem;
        color: ${colors.accent};
    }

    p {
        padding: 1rem 3rem;
        font-size: 1rem;
        background-color: ${colors.lightGray};
    }
`;

export function License() {
    const licenseList = LicenseList;

    return (
        <LicenseContainer>
            <h3>License</h3>
            <section>
                {licenseList.map(license => 
                    <Accordion>
                        <details>
                            <summary>{license.name}{license.version && `(${license.version})`}</summary>
                            <p>{ license.content }</p>
                        </details>
                    </Accordion>
                )}
            </section>
        </LicenseContainer>
    );
}
